// import components
import { showErrorSnackbar } from 'components/shared/Snackbar';
import showError from 'components/shared/showError';

// import hooks
import { useMemo } from 'react';

// import queries & mutations
import { useCreateResource } from './useCreateResource';
import { useUpdateResource } from './useUpdateResource';
import { UseSaveResourceParams } from './useSaveResource.types';

// import types
import { AxiosError } from 'axios';

export const useSaveResource = ({
  url,
  params,
  id,
  invalidateQueryKey,
  message,
  isCopy
}: UseSaveResourceParams) => {
  const create = useCreateResource({
    url,
    params,
    invalidateQueryKey,
    message
  });
  const update = useUpdateResource({
    url,
    params,
    id: id!,
    message,
    invalidateQueryKey
  });

  const defaultOnError = (error: AxiosError) => {
    message?.error ? showErrorSnackbar(message.error) : showError(error);
  };

  const mutation = isCopy ? create : id ? update : create;

  return useMemo(() => {
    return {
      ...mutation,
      mutate: (vars: any, opts: Parameters<typeof mutation.mutate>[1] = {}) => {
        mutation.mutate(vars, {
          ...opts,
          onError: opts.onError ?? defaultOnError
        });
      }
    };
  }, [mutation, defaultOnError, create, update, id, isCopy]);
};
